import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

import {AppserviceService} from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

import * as myGlobals from 'src/app/globals';


@Component({
  selector: 'app-move',
  templateUrl: './move.component.html',
  styleUrls: ['./move.component.sass']
})
export class MoveComponent implements OnInit {
  isLinear = false;
  moveForm:any;

  step1form:any;
  step2form:any;
  //step3form:any;
  
  stepone:string = '';
  steptwo:string = '';
  steponesuccess:string = '';
  steptwosuccess:string = '';
  steponeb:boolean = false;
  steptwob:boolean = false;
  transferPartBool:boolean = false;
  // isRslToRsl:boolean = false;
  checkConsignBool = 1;

  feEngineers:any = [];
  rslStores:any = [];
  partsData:any = [];
  searchedParts:any = [];
  moveServiceObj:any;
  selectedPart:any = [];

  storevalue:string ='';
  validCourierNo:boolean =false;
  // consNumValid:boolean = true;
  norecords:boolean = false;

  norecordsMsg:string;
  validators = [Validators.required];

  movefrom = [];
  moveto = [];
  fromValue = [];
  toValue = [];
  moveModel = {
    'issue_asset_from_type':'',
    'issue_asset_to_type':'',
    'from_store':'',
    'to_store':'',
    'consignmentMethod':'',
    'consignment_code':'',
    'sealedonsite':'',
    'courierno':''
  };
  moveSuccessMsg = '';
  moveTransferStatus:boolean;
  moveTransferClass = '';

  consignObj = {};
  consignmentfound:boolean = false;
  consignmentReciepted:boolean = false;
  consignmentMessage:string = '';
  consignmentValidCheck:boolean = false; 
  testlinkBol:boolean = false;
  testlinkObj = myGlobals.testlinkobj;
  testLinkWO = "";

  rslCheck:boolean = false;
  transferCheck:boolean = false;

  constructor(private _formBuilder: FormBuilder, private AppService:AppserviceService, private spinner:NgxSpinnerService) {
    this.spinner.show();
    this.AppService.fetchFeEngineers().subscribe((feData) => {
      this.spinner.hide();
      this.AppService.setEngData(feData['data']);
      this.feEngineers = feData['data'];
    });
    this.AppService.rslStores('').subscribe((rslData) => {
      this.spinner.hide();
      this.AppService.setRslData(rslData['data']);
      this.rslStores = rslData['data'];
    });
  }

  fromToCheck(){
    this.stepone = '';
    this.steponesuccess = '';
    this.steponeb = false;
    this.rslCheck = false;
    this.moveModel.consignmentMethod = "";
    this.steptwo = '';
    this.steptwosuccess = '';
    this.steptwob = false;
    this.step2form.reset();
    this.testlinkBol = false;
    this.transferCheck = false;
  }

  step1(){
    this.stepone = 'border-success';
    this.steponesuccess = 'bg-success';
    this.steponeb = true;
    this.step2form.reset();
    if((this.step1form.value.issue_asset_from_type === this.step1form.value.issue_asset_to_type) && this.step1form.value.issue_asset_from_type === 'RSL'){
      this.rslCheck = true;
      this.moveModel.consignmentMethod = '3RD-PARTY';
      if(this.step2form.get('consignmentMethod'))this.step2form.removeControl('consignmentMethod');
      //this.step2form.value.consignmentmethod.setValue('3RD-PARTY');
      this.step2form.addControl('consignmentMethod', new FormControl('3RD-PARTY',this.validators));
      this.step2form.addControl('courierno', new FormControl(this.moveModel.courierno, this.validators));
      console.log(this.step2form.value);
    }else{
      this.rslCheck = false;
      if(this.step2form.get('consignmentMethod'))this.step2form.removeControl('consignmentMethod');
      if(this.step2form.get('courierno'))this.step2form.removeControl('courierno');
      this.step2form.addControl('consignmentMethod', new FormControl(this.moveModel.consignmentMethod,this.validators));
      console.log(this.step2form.value);
    }
  }

  step2(){
    console.log(this.step2form, this.step2form.value.issue_asset_to);

    if(this.step2form.value.to_store === "TESTLINK"){
      this.testlinkBol = true;
    }/*else{ */
    this.moveServiceObj = this.step2form.value;
    this.moveServiceObj['quick_in'] = (this.step1form.value.issue_asset_from_type != this.step1form.value.issue_asset_to_type) ? 1 : (this.step2form.value.issue_asset_to === 'QUARANTINE') ? 1 : 0;
    this.moveServiceObj['engineer'] = localStorage.getItem('username');
    this.moveServiceObj['from_bin'] = (this.step1form.value.issue_asset_from_type === 'FE')?'FEBIN':'GOODSIN';
    this.moveServiceObj['to_bin'] = (this.step1form.value.issue_asset_to_type === 'FE')?'FEBIN':'GOODSIN';
    this.moveServiceObj['clear_reservations'] = (this.step1form.value.issue_asset_to_type === 'FE')?1:0;
    this.moveServiceObj['create_reservations'] = 0;
    this.moveServiceObj['courierno'] = (this.step2form.value.courierno != undefined)? this.step2form.value.courierno : '';
    this.moveServiceObj['cons_method'] = this.moveModel.consignmentMethod;
    
    if((this.moveModel.consignmentMethod !== '3RD-PARTY') || (this.moveModel.consignmentMethod === '3RD-PARTY' && this.moveModel.courierno != null)){
      if(this.moveModel.consignmentMethod === '3RD-PARTY')this.moveServiceObj['quick_in'] = 0;
      console.log(this.moveServiceObj);
      this.spinner.show();
      this.AppService.getParts(this.moveServiceObj['from_store']).subscribe((partsData) => {
        this.spinner.hide();
        this.searchedParts = this.partsData = partsData['data'];
        console.log(this.partsData.length);
        if(this.partsData.length != 0){
          this.steptwo = 'border-success';
          this.steptwosuccess = 'bg-success';
          this.steptwob = true;
          this.norecords = false;
        }else{
          this.norecords = true;
          this.norecordsMsg = 'No parts found for transfer!';
        }
        this.checkIncmngFeParts();
      });
    }
    //}   
   /*  my $engineer = $cgi->param('engineer');
    my $issue_asset_from = $cgi->param('issue_asset_from');
    my $issue_asset_to = $cgi->param('issue_asset_to');
    my $viperbagno = $cgi->param('viperbagno');
    my $issue_asset_from_type = $cgi->param('issue_asset_from_type');
    my $issue_asset_to_type = $cgi->param('issue_asset_to_type');

    my $consignmentMethod = $cgi->param('consignmentMethod');
    my $courierReference = $cgi->param('courierReference');

    my $from_bin = $issue_asset_from_type eq 'FE'  ? 'FEBIN' : 'GOODSIN';
    my $to_bin = $issue_asset_to_type eq 'FE' ? 'FEBIN' : 'GOODSIN'; */

  }

  searchConNo(consign){
    console.log(this.step2form.value);
    this.steptwob = false;
    console.log(`Matching ${this.step2form.value.courierno} and ${this.step2form.value.consignment_code}`);
    if (this.step2form.value.courierno === this.step2form.value.consignment_code) {
      this.validCourierNo = true;
      return;
    }
    this.validCourierNo = false;
    let consignmentObj = {};
    consignmentObj['AutoReceipt'] = true;
    consignmentObj['CCH_PART'] = '';
    consignmentObj['CCH_TOSTORE'] = this.step2form.value.to_store;
    consignmentObj['CCH_FROMSTORE'] = this.step2form.value.from_store;
    consignmentObj['CCH_CONSIGNMENT_NUMBER'] = this.step2form.value.consignment_code;
    if (this.step2form.value.consignment_code.length < 11) {
      return;
    }
    // consignmentObj['COURIERNO'] = this.moveServiceObj.courierno;
    console.log('searchConNo');
    /*
    this.consignObj = {
      'CCH_PART':'',
      'CCH_CONSIGNMENT_NUMBER': consign.target.value,
      'CCH_TOSTORE': this.step2form.value.to_store
    };
    */
    this.consignmentfound = false;
    this.spinner.show();
    //console.log(this.step2form.value.to_store);
    this.AppService.checkValidConsigment(consignmentObj).subscribe(
      (consignData) => {
        // console.log('I AM HERERERERE');
        this.spinner.hide();
        console.log(consignData);
        if(consignData['data'].length != 0){
          //this.consignmentObj = consignData['data'][0];
          if (consignData['code'] === 1) {
            this.consignmentfound = false;
            this.consignmentReciepted = true;
            this.consignmentMessage = consignData['message'];
          }
          else if (consignData['code'] === 2) {
            this.consignmentfound = true;
            this.consignmentReciepted = false;
            this.consignmentMessage = consignData['message'];
          }
          else {
            this.consignmentfound = true;
            this.consignmentMessage = 'Consignment number already used';
          }
        }else{
          this.consignmentfound = false;
        }
      },
      (err) => { this.spinner.hide(); }
    );

  }

  checkIncmngFeParts(){
    let consignmentObj = {};
    console.log('IncomingFeParts');
    consignmentObj['CCH_PART'] = '';
    consignmentObj['CCH_TOSTORE'] = this.step2form.value.from_store;
    consignmentObj['CCH_CONSIGNMENT_NUMBER'] = this.step2form.value.consignment_code;
    this.spinner.show();
    this.AppService.checkValidConsigment(consignmentObj).subscribe(
      (conChk) => {
        this.spinner.hide();
        console.log(conChk['data']);
        if(conChk['data'].length != 0){
          this.checkConsignBool = 0;
          this.partsData.push(conChk['data'][0]);
        }
        console.log(this.partsData);
      },
      (err) => {
        this.spinner.hide();
        console.log(err);
      }
    )
  }

  checkMethod(methValue){
    if(methValue.target.value === '3RD-PARTY'){
      console.log(this.step2form);
      this.moveModel.consignmentMethod = '3RD-PARTY';
      this.step2form.addControl('courierno', new FormControl(this.moveModel.courierno, this.validators));
    }else{
      this.moveModel.consignmentMethod = 'ENG-REND';
      this.step2form.removeControl('courierno');
      this.step2form.addControl('consignmentMethod', new FormControl(this.moveModel.consignmentMethod,this.validators));
    }
  }
  checkForm2(){
    console.log(this.step2form,   this.step2form.status)
  }

  // Check consignment between From and To stores
  checkConsignment(part,valuecheck){
    //console.log(this.step2form.value);
    let consignmentObj = {};
    consignmentObj['CCH_PART'] = part.bis_part;
    consignmentObj['CCH_TOSTORE'] = this.step2form.value.issue_asset_to;
    consignmentObj['CCH_CONSIGNMENT_NUMBER'] = this.step2form.value.viperbagno;
    //console.log(consignmentObj);
    this.AppService.checkValidConsigment(consignmentObj).subscribe(
      (conChk) => {
        //console.log(conChk['data']);
        if(conChk['data'].length == 0){
          this.consignmentValidCheck = true;
          if(!this.testlinkBol){
            this.checkConsignBool = 0;
            this.transferCheck = true;
          }else{
            this.transferCheck = false;
          }  
          this.moveSuccessMsg = conChk['message'];
        }else{
          this.checkConsignBool = 1;
          this.consignmentValidCheck = false;
          this.norecords = true;
          this.transferPartBool = true;
          this.moveTransferStatus = false;
          this.moveSuccessMsg = myGlobals.appMessages['move']['error']['iden-consignno'] + this.step2form.value.viperbagno;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  statusSelected(event){
    console.log(event);
    this.checkConsignBool = 0;
    this.transferCheck = true;
    this.moveServiceObj['repair_status'] = event.target.value;
  }

  // Raising reciept for moving part
  transfer(){
    if(this.testlinkBol)this.moveServiceObj['wo_id'] = (this.testLinkWO.length != 0)?this.testLinkWO:'999999';
    if(this.moveServiceObj.to_bin === 'FEBIN')this.moveServiceObj['quick_in'] = 1;
    console.log(this.moveServiceObj.to_bin);
    this.spinner.show();
    if(this.testlinkBol){
      this.moveServiceObj['eng_code'] = this.moveServiceObj['from_store'];
      //this.moveServiceObj['repair_status'] = this.moveServiceObj.to_bin;
      this.moveServiceObj['asset_no'] = null;
      this.moveServiceObj['rsl_code'] = 'TESTLINK';
      this.moveServiceObj['return_comment'] = 'RSL return part ' + this.moveServiceObj.to_bin;
      this.moveServiceObj['bin_code'] = this.moveServiceObj.from_bin;
      this.moveServiceObj['allow_part_create'] = 0;
      //['part_code','eng_code', 'qty', 'repair_status', 'asset_no', 'wo_id', 'consignment_code' , 'return_comment', 'user_code']
      this.AppService.returnParts(this.moveServiceObj).subscribe(
        (returnObj) => {
          console.log('RSL part returned');
          this.spinner.hide();
          this.transferPartBool = true;
          this.moveTransferClass = myGlobals.appMessages['classes']['success'];
          this.moveSuccessMsg = 'Part return from ' + this.moveServiceObj['from_store'];
          this.fromToCheck();
        },
        (error) => {
          console.log('RSL part return not success!');
          this.spinner.hide();
          console.log(error);
          this.transferPartBool = true;
          this.moveTransferStatus = error['success'];
        }
      );
    }else{
      this.AppService.issueParts(this.moveServiceObj).subscribe(
        (moveObjRec) => {
          this.spinner.hide();
          console.log(this.moveServiceObj, this.moveServiceObj.cons_method, this.moveServiceObj.to_bin,this.moveServiceObj.from_bin);
          this.transferPartBool = true;
          this.moveTransferStatus = moveObjRec['success'];
          if(this.moveServiceObj.cons_method === '3RD-PARTY' && this.moveServiceObj.to_bin === 'GOODIN' && this.moveServiceObj.from_bin === 'FEBIN') {
            this.moveSuccessMsg = myGlobals.appMessages['move']['successRsl'];
          }
          else {
            this.moveSuccessMsg = this.rslCheck === true ? myGlobals.appMessages['move']['successRsl'] : myGlobals.appMessages['move']['success'];
          }
          this.moveTransferClass = myGlobals.appMessages['classes']['success'];
          this.fromToCheck();
        },
        (err) => {
          this.spinner.hide();
          console.log(err);
          this.transferPartBool = true;
          this.moveTransferStatus = err['success'];
          this.moveSuccessMsg = myGlobals.appMessages['move']['error']['default'] + ' ' + err['error']['message']['message'];
          this.moveTransferClass = myGlobals.appMessages['classes']['error'];
        }
      );
    }
    //console.log(this.moveServiceObj);   
    
  }

  validateCheck(cValue){
    this.steptwob = false;
    (cValue.target.value === this.step2form.value.consignment_code)? this.validCourierNo = true : this.validCourierNo = false;
  }

  selectPart(part){
    this.moveServiceObj['qty'] = 1;
    this.moveServiceObj['part_code'] = part.bis_part;
    this.moveServiceObj['wo_id'] = '';
    //this.moveServiceObj['part'] = part;
    this.selectedPart['part'] = part;
    console.log(this.moveServiceObj, this.selectedPart,this.testlinkBol);
    if(part.direction != 'incoming')this.checkConsignment(part, 'to');
  }

  setFromStore(fromStore){
    if(fromStore === 'FE'){
      this.fromValue = this.movefrom = this.feEngineers;
    }else{
      this.fromValue = this.movefrom = this.rslStores;
    }
  }

  setToStore(toStore){
    if(toStore === 'FE'){
      this.toValue = this.moveto = this.feEngineers;
    }else{
      this.toValue = this.moveto = this.rslStores;
    }
  }

  changeSelected() {
    this.steptwob = false;
    this.selectedPart['part'] = [];
    this.partsData = [];
    this.testlinkBol = false;
    this.transferCheck = false;
  }

  movechangefn(event,searchBy){
    //console.log(event.target.value, event.target.value.length);
    this.steptwob = false;
    var _sV = event.target.value.toUpperCase();
    if(searchBy === 'from'){
      if(event.target.value.length === 1){
        this.fromValue = Object.assign([], this.movefrom).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'], item['name'].charAt(0) === _sV);
            if(_sV === item['name'].charAt(0)){
              //console.log(item);
              return item;
            }
        });
      }else{
        this.fromValue = Object.assign([], this.movefrom).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'].indexOf(event.target.value));
            if(item['name'].indexOf(_sV) > -1){
              //console.log(item);
              return item;
            }
        });
      }
    }else{
      if(event.target.value.length === 1){
        this.toValue = Object.assign([], this.moveto).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'], item['name'].charAt(0) === _sV);
            if(_sV === item['name'].charAt(0)){
              //console.log(item);
              return item;
            }
        });
      }else{
        this.toValue = Object.assign([], this.moveto).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'].indexOf(_sV));
            if(item['name'].indexOf(_sV) > -1){
              //console.log(item);
              return item;
            }
        });
      }
    }
    //console.log(this.movefrom, this.moveto);
    /* this.AppService.getMoveService('move',event.target.value).subscribe((dataObj) => {
      console.log(dataObj, value);
      if(value === 'from'){
        this.movefrom = dataObj['data'];
      }else{
        this.moveto = dataObj['data'];
      }
    }); */
  }

  searchStore(event){
    var _sV = event.target.value.toUpperCase();

    this.searchedParts = Object.assign([], this.partsData).filter(item => {
      //if(event.target.value.length == 1){
        //console.log(item['name'], item['name'].charAt(0) === _sV);
        for(let key in item){
          //console.log(_sV, item[key].toString().charAt(0), item[key]);
          if((item[key] != null) && item[key].toString().toUpperCase().indexOf(_sV) > -1){
            return item;
          }
        }
        /* if(item['par_desc'].indexOf(_sV) > -1){
          //console.log(item);
          return item;
        } */
    });
  }

  ngOnInit() {
    this.step1form = new FormGroup({
      'issue_asset_from_type':new FormControl(this.moveModel.issue_asset_from_type,[
        Validators.required
      ]),
      'issue_asset_to_type':new FormControl(this.moveModel.issue_asset_to_type,[
        Validators.required
      ])
    });

    this.step2form = new FormGroup({
      'from_store':new FormControl(this.moveModel.from_store,[
        Validators.required
      ]),
      'to_store':new FormControl(this.moveModel.to_store,[
        Validators.required
      ]),
      'consignment_code':new FormControl(this.moveModel.consignment_code,[
        Validators.required
      ]),
      'sealedonsite':new FormControl(this.moveModel.sealedonsite,[
        Validators.required
      ])
    });

  }

}
